import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Persist session in localStorage so users don't have to re-auth
    // on every browser restart. Default is true but explicit is better.
    persistSession: true,
    // Auto-refresh the access token before it expires. The refresh token
    // lifetime is set in the Supabase dashboard (recommended: 90 days).
    autoRefreshToken: true,
    // Detect session in URL (used after the OAuth callback). Default true,
    // explicit so future contributors don't accidentally disable it.
    detectSessionInUrl: true,
    // Storage key — default works, leaving for clarity. Sessions live in
    // localStorage under this key; clearing it logs the user out.
    storageKey: 'sb-mediloop-auth',
    // PKCE flow — more secure than implicit. Default for new SDK versions.
    flowType: 'pkce',
  },
});
